// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/PeladaDetails.css */
:root {
  --bg: #0b0d12;
  --card: #11141b;
  --card-2: #0f1218;
  --text: #e7edf6;
  --muted: #a6b0c3;
  --border: #1c2330;
  --brand: #22c55e;
  --brand-2: #16a34a;
  --danger: #ef4444;
  --info: #3b82f6;

  --radius: 16px;
  --radius-sm: 12px;
  --shadow: 0 8px 24px rgba(0,0,0,0.35);
  --shadow-soft: 0 6px 18px rgba(0,0,0,0.25);

  --gap: 16px;
  --gap-lg: 24px;

  --menu-h: 72px;
}

* { box-sizing: border-box; }
html, body, #root { height: 100%; }
html, body { width: 100%; overflow-x: hidden; -webkit-text-size-adjust: 100%; }
img, svg, video { max-width: 100%; height: auto; }

body {
  margin: 0;
  background: linear-gradient(180deg, #0a0c10 0%, #0b0d12 100%);
  color: var(--text);
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Inter, "Helvetica Neue", Arial, "Noto Sans";
}

/* Header fixo compartilhado com o app */
.topbar {
  position: fixed;
  top: 0; left: 0; right: 0;
  height: var(--menu-h);
  z-index: 60;
  background: var(--bg);
  border-bottom: 1px solid var(--border);
  display: grid;
  align-items: center;
}

/* Página */
.pd-page {
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr;
  padding-top: calc(var(--menu-h) + env(safe-area-inset-top));
}

/* Conteúdo */
.pd-content {
  padding: 16px clamp(12px, 4vw, 32px);
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

/* Header da página */
.pd-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--gap);
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.pd-title {
  margin: 0;
  font-size: clamp(20px, 4vw, 28px);
  font-weight: 800;
  letter-spacing: .2px;
}
.pd-subtitle {
  margin: 4px 0 0;
  color: var(--muted);
  font-size: 14px;
}
.pd-actions { display: flex; gap: 10px; flex-wrap: wrap; }

/* Grid principal: detalhes + lista */
.pd-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--gap-lg);
  min-width: 0;
}
@media (min-width: 980px) { .pd-grid { grid-template-columns: 1fr 1fr; } }

/* Card */
.pd-card {
  background:
    radial-gradient(900px 320px at 110% -20%, rgba(34,197,94,.08), transparent),
    radial-gradient(700px 260px at -10% 115%, rgba(59,130,246,.06), transparent),
    linear-gradient(180deg, var(--card) 0%, var(--card-2) 100%);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px;
  box-shadow: var(--shadow);
  min-width: 0;
}
.pd-card-head {
  display: flex; align-items: center; justify-content: space-between;
  gap: 10px; margin-bottom: 12px;
}
.pd-card-head h2 { margin: 0; font-size: 18px; letter-spacing: .2px; }
.pd-card-body { min-width: 0; }

/* Utilitários para usar dentro dos componentes filhos (PeladaDetalhes/ListaJogadores) */
.pd-row { display: grid; grid-template-columns: auto 1fr; gap: 10px; align-items: start; }
.pd-label { color: var(--muted); font-size: 12px; white-space: nowrap; }
.pd-value { font-size: 14px; overflow-wrap: anywhere; text-align: right; }

.pd-badge {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 12px; font-weight: 800; padding: 6px 10px; border-radius: 999px;
  border: 1px solid var(--border); background: #0c0f14;
}
.pd-badge--open { color: #22c55e; background: rgba(34,197,94,0.12); border-color: rgba(34,197,94,0.22); }
.pd-badge--closed { color: #f59e0b; background: rgba(245,158,11,0.12); border-color: rgba(245,158,11,0.22); }
.pd-badge--scheduled { color: #3b82f6; background: rgba(59,130,246,0.12); border-color: rgba(59,130,246,0.22); }
.pd-badge--live { color: #f43f5e; background: rgba(244,63,94,0.12); border-color: rgba(244,63,94,0.22); }
.pd-badge--finished { color: #9ca3af; background: rgba(156,163,175,0.12); border-color: rgba(156,163,175,0.22); }
.pd-badge--canceled { color: #ef4444; background: rgba(239,68,68,0.12); border-color: rgba(239,68,68,0.22); }

/* Lista de jogadores utilitários */
.pd-list { list-style: none; margin: 0; padding: 0; display: grid; gap: 12px; }
.pd-item {
  border: 1px solid var(--border);
  border-radius: 14px;
  background: linear-gradient(180deg, #0c0f14 0%, #0d1016 100%);
  padding: 12px;
  display: grid; gap: 8px;
}
.pd-item-top { display: grid; grid-template-columns: auto 1fr auto; gap: 10px; align-items: center; }
.pd-avatar {
  width: 34px; height: 34px; border-radius: 10px; display: grid; place-items: center;
  background: rgba(34,197,94,0.12); border: 1px solid rgba(34,197,94,0.22); color: #86efac; font-weight: 800;
}
.pd-name { font-weight: 800; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pd-sub { color: var(--muted); font-size: 12px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* Chips compactos (ex.: goleiro/linha, pago/não pago) */
.chip {
  display: inline-flex; align-items: center; gap: 6px;
  border: 1px solid var(--border); border-radius: 999px;
  padding: 4px 8px; font-size: 12px; font-weight: 700;
  background: #0c0f14; color: var(--text);
}
.chip--ok { color: #86efac; border-color: rgba(34,197,94,0.35); background: rgba(34,197,94,0.08); }
.chip--warn { color: #facc15; border-color: rgba(250,204,21,0.35); background: rgba(250,204,21,0.08); }
.chip--bad { color: #fca5a5; border-color: rgba(239,68,68,0.35); background: rgba(239,68,68,0.08); }

/* Botões padrão do app */
.btn {
  border: 1px solid var(--border);
  background: #0c0f14;
  color: var(--text);
  padding: 10px 12px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all .2s ease;
}
.btn:hover { transform: translateY(-1px); box-shadow: var(--shadow-soft); }
.btn--ghost { background: transparent; border: 1px solid var(--border); }
.btn--primary {
  background: linear-gradient(180deg, var(--brand) 0%, var(--brand-2) 100%);
  border: none; color: #041107;
}
.btn--danger {
  background: linear-gradient(180deg, var(--danger), #c23b3b);
  border: none; color: #fff;
}

/* Loader overlay */
.loader-overlay {
  position: fixed; inset: 0;
  background: rgba(6, 8, 12, 0.6);
  backdrop-filter: blur(3px);
  display: grid; place-items: center;
  z-index: 80;
}
.loader-spinner {
  width: 44px; height: 44px; border-radius: 999px;
  border: 3px solid #1f2937; border-top-color: var(--brand);
  animation: spin 1s linear infinite; margin-bottom: 10px;
}
.loader-text { text-align: center; color: var(--muted); }
@keyframes spin { to { transform: rotate(360deg); } }

/* Acessibilidade */
button:focus-visible, .btn:focus-visible {
  outline: 2px solid var(--info);
  outline-offset: 2px;
}

/* Ajustes micro para telas estreitas */
@media (max-width: 380px) {
  .btn { padding: 9px 10px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PeladaDetails.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;;EAEf,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,0CAA0C;;EAE1C,WAAW;EACX,cAAc;;EAEd,cAAc;AAChB;;AAEA,IAAI,sBAAsB,EAAE;AAC5B,oBAAoB,YAAY,EAAE;AAClC,aAAa,WAAW,EAAE,kBAAkB,EAAE,8BAA8B,EAAE;AAC9E,kBAAkB,eAAe,EAAE,YAAY,EAAE;;AAEjD;EACE,SAAS;EACT,6DAA6D;EAC7D,kBAAkB;EAClB,mHAAmH;AACrH;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,qBAAqB;EACrB,WAAW;EACX,qBAAqB;EACrB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,aAAa;EACb,4BAA4B;EAC5B,2DAA2D;AAC7D;;AAEA,aAAa;AACb;EACE,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;AACA,cAAc,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;;AAEzD,qCAAqC;AACrC;EACE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;AACd;AACA,4BAA4B,WAAW,8BAA8B,EAAE,EAAE;;AAEzE,SAAS;AACT;EACE;;;+DAG6D;EAC7D,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,SAAS,EAAE,mBAAmB;AAChC;AACA,mBAAmB,SAAS,EAAE,eAAe,EAAE,oBAAoB,EAAE;AACrE,gBAAgB,YAAY,EAAE;;AAE9B,wFAAwF;AACxF,UAAU,aAAa,EAAE,+BAA+B,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACzF,YAAY,mBAAmB,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACvE,YAAY,eAAe,EAAE,uBAAuB,EAAE,iBAAiB,EAAE;;AAEzE;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,oBAAoB;EAC1E,+BAA+B,EAAE,mBAAmB;AACtD;AACA,kBAAkB,cAAc,EAAE,gCAAgC,EAAE,kCAAkC,EAAE;AACxG,oBAAoB,cAAc,EAAE,iCAAiC,EAAE,mCAAmC,EAAE;AAC5G,uBAAuB,cAAc,EAAE,iCAAiC,EAAE,mCAAmC,EAAE;AAC/G,kBAAkB,cAAc,EAAE,gCAAgC,EAAE,kCAAkC,EAAE;AACxG,sBAAsB,cAAc,EAAE,kCAAkC,EAAE,oCAAoC,EAAE;AAChH,sBAAsB,cAAc,EAAE,gCAAgC,EAAE,kCAAkC,EAAE;;AAE5G,mCAAmC;AACnC,WAAW,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,aAAa,EAAE,SAAS,EAAE;AAC9E;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,aAAa,EAAE,QAAQ;AACzB;AACA,eAAe,aAAa,EAAE,oCAAoC,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACpG;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,aAAa,EAAE,mBAAmB;EAClF,gCAAgC,EAAE,sCAAsC,EAAE,cAAc,EAAE,gBAAgB;AAC5G;AACA,WAAW,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC7F,UAAU,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAEhH,wDAAwD;AACxD;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,+BAA+B,EAAE,oBAAoB;EACrD,gBAAgB,EAAE,eAAe,EAAE,gBAAgB;EACnD,mBAAmB,EAAE,kBAAkB;AACzC;AACA,YAAY,cAAc,EAAE,kCAAkC,EAAE,gCAAgC,EAAE;AAClG,cAAc,cAAc,EAAE,mCAAmC,EAAE,iCAAiC,EAAE;AACtG,aAAa,cAAc,EAAE,kCAAkC,EAAE,gCAAgC,EAAE;;AAEnG,yBAAyB;AACzB;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;AACA,aAAa,2BAA2B,EAAE,8BAA8B,EAAE;AAC1E,cAAc,uBAAuB,EAAE,+BAA+B,EAAE;AACxE;EACE,yEAAyE;EACzE,YAAY,EAAE,cAAc;AAC9B;AACA;EACE,2DAA2D;EAC3D,YAAY,EAAE,WAAW;AAC3B;;AAEA,mBAAmB;AACnB;EACE,eAAe,EAAE,QAAQ;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa,EAAE,mBAAmB;EAClC,WAAW;AACb;AACA;EACE,WAAW,EAAE,YAAY,EAAE,oBAAoB;EAC/C,yBAAyB,EAAE,8BAA8B;EACzD,kCAAkC,EAAE,mBAAmB;AACzD;AACA,eAAe,kBAAkB,EAAE,mBAAmB,EAAE;AACxD,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,OAAO,iBAAiB,EAAE;AAC5B","sourcesContent":["/* src/pages/PeladaDetails.css */\n:root {\n  --bg: #0b0d12;\n  --card: #11141b;\n  --card-2: #0f1218;\n  --text: #e7edf6;\n  --muted: #a6b0c3;\n  --border: #1c2330;\n  --brand: #22c55e;\n  --brand-2: #16a34a;\n  --danger: #ef4444;\n  --info: #3b82f6;\n\n  --radius: 16px;\n  --radius-sm: 12px;\n  --shadow: 0 8px 24px rgba(0,0,0,0.35);\n  --shadow-soft: 0 6px 18px rgba(0,0,0,0.25);\n\n  --gap: 16px;\n  --gap-lg: 24px;\n\n  --menu-h: 72px;\n}\n\n* { box-sizing: border-box; }\nhtml, body, #root { height: 100%; }\nhtml, body { width: 100%; overflow-x: hidden; -webkit-text-size-adjust: 100%; }\nimg, svg, video { max-width: 100%; height: auto; }\n\nbody {\n  margin: 0;\n  background: linear-gradient(180deg, #0a0c10 0%, #0b0d12 100%);\n  color: var(--text);\n  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Inter, \"Helvetica Neue\", Arial, \"Noto Sans\";\n}\n\n/* Header fixo compartilhado com o app */\n.topbar {\n  position: fixed;\n  top: 0; left: 0; right: 0;\n  height: var(--menu-h);\n  z-index: 60;\n  background: var(--bg);\n  border-bottom: 1px solid var(--border);\n  display: grid;\n  align-items: center;\n}\n\n/* Página */\n.pd-page {\n  min-height: 100vh;\n  display: grid;\n  grid-template-rows: auto 1fr;\n  padding-top: calc(var(--menu-h) + env(safe-area-inset-top));\n}\n\n/* Conteúdo */\n.pd-content {\n  padding: 16px clamp(12px, 4vw, 32px);\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* Header da página */\n.pd-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--gap);\n  flex-wrap: wrap;\n  margin-bottom: 24px;\n}\n.pd-title {\n  margin: 0;\n  font-size: clamp(20px, 4vw, 28px);\n  font-weight: 800;\n  letter-spacing: .2px;\n}\n.pd-subtitle {\n  margin: 4px 0 0;\n  color: var(--muted);\n  font-size: 14px;\n}\n.pd-actions { display: flex; gap: 10px; flex-wrap: wrap; }\n\n/* Grid principal: detalhes + lista */\n.pd-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--gap-lg);\n  min-width: 0;\n}\n@media (min-width: 980px) { .pd-grid { grid-template-columns: 1fr 1fr; } }\n\n/* Card */\n.pd-card {\n  background:\n    radial-gradient(900px 320px at 110% -20%, rgba(34,197,94,.08), transparent),\n    radial-gradient(700px 260px at -10% 115%, rgba(59,130,246,.06), transparent),\n    linear-gradient(180deg, var(--card) 0%, var(--card-2) 100%);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 16px;\n  box-shadow: var(--shadow);\n  min-width: 0;\n}\n.pd-card-head {\n  display: flex; align-items: center; justify-content: space-between;\n  gap: 10px; margin-bottom: 12px;\n}\n.pd-card-head h2 { margin: 0; font-size: 18px; letter-spacing: .2px; }\n.pd-card-body { min-width: 0; }\n\n/* Utilitários para usar dentro dos componentes filhos (PeladaDetalhes/ListaJogadores) */\n.pd-row { display: grid; grid-template-columns: auto 1fr; gap: 10px; align-items: start; }\n.pd-label { color: var(--muted); font-size: 12px; white-space: nowrap; }\n.pd-value { font-size: 14px; overflow-wrap: anywhere; text-align: right; }\n\n.pd-badge {\n  display: inline-flex; align-items: center; gap: 6px;\n  font-size: 12px; font-weight: 800; padding: 6px 10px; border-radius: 999px;\n  border: 1px solid var(--border); background: #0c0f14;\n}\n.pd-badge--open { color: #22c55e; background: rgba(34,197,94,0.12); border-color: rgba(34,197,94,0.22); }\n.pd-badge--closed { color: #f59e0b; background: rgba(245,158,11,0.12); border-color: rgba(245,158,11,0.22); }\n.pd-badge--scheduled { color: #3b82f6; background: rgba(59,130,246,0.12); border-color: rgba(59,130,246,0.22); }\n.pd-badge--live { color: #f43f5e; background: rgba(244,63,94,0.12); border-color: rgba(244,63,94,0.22); }\n.pd-badge--finished { color: #9ca3af; background: rgba(156,163,175,0.12); border-color: rgba(156,163,175,0.22); }\n.pd-badge--canceled { color: #ef4444; background: rgba(239,68,68,0.12); border-color: rgba(239,68,68,0.22); }\n\n/* Lista de jogadores utilitários */\n.pd-list { list-style: none; margin: 0; padding: 0; display: grid; gap: 12px; }\n.pd-item {\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  background: linear-gradient(180deg, #0c0f14 0%, #0d1016 100%);\n  padding: 12px;\n  display: grid; gap: 8px;\n}\n.pd-item-top { display: grid; grid-template-columns: auto 1fr auto; gap: 10px; align-items: center; }\n.pd-avatar {\n  width: 34px; height: 34px; border-radius: 10px; display: grid; place-items: center;\n  background: rgba(34,197,94,0.12); border: 1px solid rgba(34,197,94,0.22); color: #86efac; font-weight: 800;\n}\n.pd-name { font-weight: 800; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.pd-sub { color: var(--muted); font-size: 12px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n/* Chips compactos (ex.: goleiro/linha, pago/não pago) */\n.chip {\n  display: inline-flex; align-items: center; gap: 6px;\n  border: 1px solid var(--border); border-radius: 999px;\n  padding: 4px 8px; font-size: 12px; font-weight: 700;\n  background: #0c0f14; color: var(--text);\n}\n.chip--ok { color: #86efac; border-color: rgba(34,197,94,0.35); background: rgba(34,197,94,0.08); }\n.chip--warn { color: #facc15; border-color: rgba(250,204,21,0.35); background: rgba(250,204,21,0.08); }\n.chip--bad { color: #fca5a5; border-color: rgba(239,68,68,0.35); background: rgba(239,68,68,0.08); }\n\n/* Botões padrão do app */\n.btn {\n  border: 1px solid var(--border);\n  background: #0c0f14;\n  color: var(--text);\n  padding: 10px 12px;\n  border-radius: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all .2s ease;\n}\n.btn:hover { transform: translateY(-1px); box-shadow: var(--shadow-soft); }\n.btn--ghost { background: transparent; border: 1px solid var(--border); }\n.btn--primary {\n  background: linear-gradient(180deg, var(--brand) 0%, var(--brand-2) 100%);\n  border: none; color: #041107;\n}\n.btn--danger {\n  background: linear-gradient(180deg, var(--danger), #c23b3b);\n  border: none; color: #fff;\n}\n\n/* Loader overlay */\n.loader-overlay {\n  position: fixed; inset: 0;\n  background: rgba(6, 8, 12, 0.6);\n  backdrop-filter: blur(3px);\n  display: grid; place-items: center;\n  z-index: 80;\n}\n.loader-spinner {\n  width: 44px; height: 44px; border-radius: 999px;\n  border: 3px solid #1f2937; border-top-color: var(--brand);\n  animation: spin 1s linear infinite; margin-bottom: 10px;\n}\n.loader-text { text-align: center; color: var(--muted); }\n@keyframes spin { to { transform: rotate(360deg); } }\n\n/* Acessibilidade */\nbutton:focus-visible, .btn:focus-visible {\n  outline: 2px solid var(--info);\n  outline-offset: 2px;\n}\n\n/* Ajustes micro para telas estreitas */\n@media (max-width: 380px) {\n  .btn { padding: 9px 10px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
